import { Toggles } from 'Src/ng2/shared/constants/toggles.constant';
import { ImUser } from 'Src/ng2/shared/services/im-models/im-user';

angular.module('nv.routes.main').config(function($stateProvider) {
  // redirects to default url based on the role type of currentUser
  $stateProvider.state('main.home', {
    url: '/home',
    controller(currentUser, $state, $location, ImUser: ImUser) {
      if (ImUser.isHybridUser(currentUser)) {
        // TODO - hybrid picker view... use $location.url(`/`)
        // TODO - remove the following TEMP code once hybrid picker view is coded
        if (ImUser.isShelterUser(currentUser)) {
          const shelterId = currentUser.nvRoleShelter.shelterId;
          $location.url(`/shelter/${shelterId}/lists/attendance-list`);
        }
        if (ImUser.isClusterUser(currentUser, 'shelter')) {
          $location.url('/shelter-picker');
        }
      } else if (ImUser.isSchoolUser(currentUser)) {
        // single school user, defaults to my students list view
        const schoolId = currentUser.nvRole.schoolId;
        $state.go('main.school.home', { schoolId });
      } else if (ImUser.isClusterUser(currentUser, 'school')) {
        const accessNetworkView = ImUser.isToggleOn(Toggles.TOGGLE_NETWORK_DASHBOARD);
        if (accessNetworkView) {
          // net dash view
          $state.go('main.network.dashboard');
        } else {
          // school picker view
          $state.go('main.cluster');
        }
      } else if (ImUser.isShelterUser(currentUser)) {
        // single shelter user, defaults to shelter student attendance list view
        const shelterId = currentUser.nvRoleShelter.shelterId;
        $location.url(`/shelter/${shelterId}/lists/attendance-list`);
      } else if (ImUser.isClusterUser(currentUser, 'shelter')) {
        $location.url('/shelter-picker');
      }
    },
  });
});
